import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
          <h1 className="font-raleway font-bold text-2xl text-[#161C30] mb-4">
            Something went wrong
          </h1>
          <p className="font-raleway text-base text-gray-600 mb-6">
            We're sorry, an unexpected error occurred. Please try refreshing the
            page.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="bg-[#DD8732] text-white py-2 px-6 rounded-full font-raleway font-bold text-sm hover:bg-opacity-80"
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
